import React, { useState } from 'react';
import { Form, reduxForm } from 'redux-form';
import classNames from 'classnames';
import ReactDropzone from 'react-dropzone';
import * as _ from 'lodash';
import styles from '../../styles/forms/add_file_wizard/AddFileForm.scss';
import Button from '../../components/Button';
import { __, bytesToSize } from '../../core/utils';
import UploadIcon from '../../assets/images/upload-40x40.svg';
import CloseSmallIcon from '../../assets/images/close-small-15x15.svg';

const AddFileForm = ({
  change,
  handleSubmit,
  onSubmit,
  onClose,
  submitting,
}) => {
  const [drag, setDrag] = useState(false);
  const [files, setFiles] = useState([]);

  const _handleDrop = (acceptedFiles) => {
    setDrag(false);

    if (_.isEmpty(acceptedFiles)) {
      return;
    }

    const nextFiles = [...files, ...acceptedFiles];

    setFiles(nextFiles);
    change('files', nextFiles);
  };

  const _handleRemoveFile = (fileToRemove) => {
    const nextFiles = _.filter(files, (file) => file !== fileToRemove);

    setFiles(nextFiles);
    change('files', nextFiles);
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className={styles.wrapper}>
      <div className={styles.form}>
        {!_.isEmpty(files) && (
          <div className={styles.selectedFiles}>
            {_.map(files, (file, index) => (
              <div className={styles.selectedFile} key={index}>
                <span>{file.name}</span>
                <small>{bytesToSize(file.size)}</small>
                <CloseSmallIcon onClick={() => _handleRemoveFile(file)} />
              </div>
            ))}
          </div>
        )}

        <ReactDropzone
          className={classNames(styles.dropzone, drag && styles.drag)}
          onDrop={_handleDrop}
          onDragOver={() => setDrag(true)}
          onDragLeave={() => setDrag(false)}
          multiple={true}
        >
          <UploadIcon />
          <span className={styles.dropTitle}>
            {__('dropzone.title.drop-your')} {__('dropzone.title.files')}{' '}
            {__('dropzone.title.here')}
          </span>
          <span className={styles.dropSubtitle}>
            {__('dropzone.title.or-select')}
          </span>
        </ReactDropzone>
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={onClose}
        />
        <Button
          lightBlue
          medium
          right
          submit
          disabled={_.isEmpty(files)}
          middleText={__('button.add')}
          spinning={submitting}
        />
      </div>
    </Form>
  );
};

export default reduxForm({
  form: 'add_file_wizard.add_file',
})(AddFileForm);
